// 8.3.8 Interview Practice UI (merged as `iv`).
const iv = {
 "scriptLatin": "اللاتينية",
 "scriptCyrillic": "السيريلية",
 "tabNew": "محادثة جديدة",
 "tabChats": "المحادثات",
 "tabInterview": "المقابلة",
 "cardTitle": "التدرّب على المقابلات",
 "cardSub": "تدرّب على محادثة مهمة قبل أن تحدث.",
 "promise": "تدرّب على المحادثات المهمة قبل أن تحدث.",
 "support": "اختر مقابلة أو صف مقابلتك. يتكيّف المُحاوِر مع مستواك وإجاباتك.",
 "fam": {
  "work": "العمل",
  "education": "التعليم",
  "travel": "السفر والمعاملات",
  "public": "مهني",
  "personal": "شخصي",
  "custom": "مخصّص"
 },
 "sc": {
  "job": "مقابلة عمل",
  "internship": "مقابلة تدريب",
  "promotion": "مقابلة ترقية",
  "freelance": "تقديم نفسك لعميل (عمل حر)",
  "networking": "التعارف المهني",
  "university": "القبول الجامعي",
  "scholarship": "مقابلة منحة",
  "oral_exam": "امتحان شفهي مدرسي",
  "language_exam": "امتحان لغة شفهي",
  "visa": "مقابلة شبيهة بمقابلة التأشيرة",
  "travel_questions": "أسئلة أثناء السفر",
  "hotel_problem": "مشكلة في الفندق أو السفر",
  "media": "مقابلة إعلامية/بودكاست",
  "presentation_qa": "أسئلة بعد عرض تقديمي",
  "client_meeting": "اجتماع مع عميل",
  "pro_intro": "تقديم مهني",
  "housing": "السكن/الشقة",
  "doctor": "موعد مع الطبيب",
  "meet_new": "التعرّف على شخص جديد",
  "difficult": "محادثة صعبة",
  "custom": "صف مقابلتك"
 },
 "contextLabel": "ما الذي ينبغي أن يعرفه المُحاوِر؟",
 "contextPh": "اختياري: الوظيفة، الشركة، المادة، ما يقلقك…",
 "customPh": "صف مقابلتك، مثل: «غدًا لديّ مقابلة لوظيفة موظف استقبال في فندق في مدريد».",
 "length": "المدة",
 "quick": "قصيرة — نحو 5 أسئلة",
 "standard": "عادية — نحو 10 أسئلة",
 "deep": "معمّقة — نحو 15 سؤالًا",
 "style": "أسلوب التدريب",
 "supportive": "داعم",
 "realistic": "واقعي",
 "challenging": "صارم",
 "start": "ابدأ المقابلة",
 "starting": "جارٍ تجهيز المُحاوِر…",
 "progress": "{n} من {total}",
 "answerPh": "إجابتك…",
 "send": "إرسال",
 "type": "كتابة",
 "speak": "تحدّث",
 "listen": "استمع",
 "help": "ساعدني في قولها",
 "helpPh": "اكتب ما تريد قوله بأي لغة",
 "helpGo": "أرني",
 "helpNote": "استخدمها نموذجًا، ثم اكتب إجابتك بنفسك.",
 "finished": "شكرًا، انتهت المقابلة. لنرَ كيف كان أداؤك.",
 "seeReport": "عرض ملاحظاتي",
 "building": "جارٍ إعداد ملاحظاتك…",
 "overall": "الانطباع العام",
 "areasT": "مجالات التدريب",
 "areas": {
  "clarity": "الوضوح",
  "vocabulary": "المفردات",
  "grammar": "القواعد",
  "naturalness": "الطبيعية",
  "effectiveness": "الفاعلية في المقابلة"
 },
 "lv": {
  "strong": "قوي",
  "developing": "في تطوّر",
  "needs_practice": "يحتاج إلى تدريب"
 },
 "worked": "ما نجح",
 "improve": "ما يمكن تحسينه",
 "better": "طرق أفضل للتعبير",
 "phrases": "عبارات مفيدة",
 "save": "حفظ",
 "saved": "حُفظت في المفردات",
 "history": "مقابلاتك",
 "empty": "لا توجد مقابلات بعد.",
 "resume": "متابعة",
 "startOver": "البدء من جديد",
 "view": "عرض",
 "st": {
  "active": "جارية",
  "answered": "جاهزة للملاحظات",
  "completed": "مكتملة"
 },
 "retry": "حدث خطأ ما. إجاباتك محفوظة — حاول مرة أخرى.",
 "retryBtn": "حاول مرة أخرى",
 "newInterview": "مقابلة جديدة",
 "back": "رجوع",
 "suggest": "هل لديك محادثة مهمة قريبًا؟",
 "suggestBtn": "جرّب التدرّب على المقابلات",
 "dismiss": "إخفاء",
 "recording": "جارٍ التسجيل… اضغط للإيقاف",
 "transcribing": "جارٍ التفريغ…",
 "micFail": "الصوت لا يعمل — اكتب إجابتك بدلًا من ذلك.",
 "disclaimer": "تدريب لغوي فقط — ليس استشارة قانونية أو متعلقة بالهجرة أو طبية أو توظيفية.",
 "describeFirst": "صف مقابلتك أولًا."
};
export default iv;
